<div class="main">
  <div class="dashboard-header">
    <img [src]="getImageUrl()" id="logo" alt="Logo" style="width: 150px;margin:6px;">
  </div>
  <div class="navbar" style="justify-content: space-between;">
    <div class="nav-item" style="font-size: 13px;">
      <a (click)="customer()"> Customer Profile </a>
      <!-- <div  class="dropdown">
                <a > Customer Profile</a>
            </div> -->
    </div>
    <div class="user-info" style="margin-right: 11px;">
      <!-- <span>Welcome : User</span><i class="fas fa-user" (click)="openprofilePopup();"></i> -->
      <div class="nav-item" style="font-size: 15px;">
        <span style="color: black;">Welcome : {{userName ? userName : 'User'}}</span><a><i class="fas fa-user"></i></a>
        <div class="dropdown">
          <a (click)="openAddForm(addChangePasswordModal);this.showConfirmPassword = false;
            this.showNewPassword = false;
          "> Change Password</a>
          <a (click)="openAddForm(openLogOutModel)"> Logout</a>
        </div>
      </div>
    </div>
  </div>




  <ng-container>
    <span style="position: relative; bottom: -7em; left: 1em; font-size: 12px;">
      <i class="fas fa-home"></i> / Customer Care Tool / View
    </span>
    <div class="container-fluid">
      <div class="row">
        <!-- Left Panel -->
        <div class="col-md-3" style="margin-top: 20px;">
          <div class="card">
            <div class="card-header text-center">
              <h5>Customer Care Tool</h5>
            </div>
            <div class="card-body" style="padding: 13px;">
              <form (submit)="getDetails()">
                <div class="mb-3 mt-4">
                  <label for="phone-number" class="form-label">Enter Number</label>
                  <input type="text" id="phone-number" class="form-control mt-2" placeholder="263xxxxxxxx"
                    [(ngModel)]="phoneNumber" name="phoneNumber" required (keypress)="allowOnlyNumbers($event)"
                    pattern="[0-9]*" maxlength="15" />
                </div>
                <div *ngIf="errorMessage" class="alert alert-danger">
                  {{ errorMessage }}
                </div>
                <div class="d-grid">
                  <button type="submit" class="btn btn-primary">
                    Get Details
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Right Panel -->
        <div class="col-md-7" *ngIf="showDetails"
          style="border: 1px solid #ccc; padding-left: 15px; padding-top: 15px; margin-left: 30px; width: 72%; padding-right: 15px;">
          <h5>Current Subscription Information For User</h5>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Number</th>
                <th>User Status</th>
                <th>Channel</th>
                <th>Currency</th>
                <th>Active Plan</th>
                <th>Subscription Date</th>
                <th>Renewal Date</th>
                <th>Last Charged Date</th>
                <th>Deactivation Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ currentsubscription.phone || 'N/A' }}</td>
                <td>{{ currentsubscription.accountStatus || 'N/A'}}</td>
                <td>{{ currentsubscription.channel || 'N/A'}}</td>
                <td>{{ currentsubscription.currency || 'N/A'}}</td>
                <td>{{ currentsubscription.planName || 'N/A' }}</td>
                <td>{{ currentsubscription.subsStartDate ? (currentsubscription.subsStartDate | date: 'dd-MM-yyyy, hh:mm
                  a') :
                  'N/A' }}</td>
                <td>{{ currentsubscription.renewalDate ? (currentsubscription.renewalDate | date: 'dd-MM-yyyy, hh:mm a')
                  : 'N/A'
                  }}</td>
                <td>{{ currentsubscription.lastChargeDate ? (currentsubscription.lastChargeDate | date: 'dd-MM-yyyy,
                  hh:mm a') :
                  'N/A' }}</td>
                <td>{{ currentsubscription.deactivationDate ? (currentsubscription.deactivationDate | date: 'dd-MM-yyyy,
                  hh:mm a') :
                  'N/A' }}</td>
              </tr>
            </tbody>
          </table>
          <div class="card mt-2" style="min-height: 40px;" *ngIf="currentsubscription.accountStatus === 'ACTIVE'">
            <div class="card-body text-danger mt-2" style="text-align: right;">
              <a style="font-weight: bold; padding-right: 5px; cursor: pointer;"
                (click)="openAddDeactivateForm(openDeactivateuserModel, currentsubscription.id)">
                Deactivate
              </a>
            </div>
          </div>

          <div class="mt-3">
            <div class="card mb-2" style="min-height: 40px;">
              <div class="card-body  mt-2" style="cursor: pointer;" (click)="showTransactionLogs()">
                <a style="padding-left: 13px;">Transaction Logs</a>
              </div>
            </div>
            <div class="card mt-2 mb-3" *ngIf="showLogs" style="border: 1px solid #ccc; padding: 15px;">
              <h5 class="mb-3">Transaction Logs</h5>
              <div class="row mb-3">
                <div class="col-md-9">
                  <label for="rowsPerPage" class="form-label me-2">Rows per page:</label>
                  <select id="rowsPerPage" class="form-select d-inline-block w-auto" [(ngModel)]="rowsPerPage"
                    (change)="updatePagination()">
                    <option *ngFor="let size of pageSizes" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 text-end">
                  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchQuery"
                    (ngModelChange)="filterTransactions()" />
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr style="text-align: center;">
                      <th (click)="sortTable('toneCode')">Product Name <span [class]="getSortIcon('toneCode')"></span>
                      </th>
                      <th (click)="sortTable('date')">Date <span [class]="getSortIcon('date')"></span></th>
                      <th (click)="sortTable('amount')">Amount <span [class]="getSortIcon('amount')"></span></th>
                      <th (click)="sortTable('currency')">Currency <span [class]="getSortIcon('currency')"></span></th>
                      <th (click)="sortTable('type')">Type <span [class]="getSortIcon('type')"></span></th>
                      <th (click)="sortTable('mode')">Charging Mode <span [class]="getSortIcon('mode')"></span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="!errorMessagetransaction && paginatedTransactions.length">
                      <tr *ngFor="let transaction of paginatedTransactions; let i = index" style="text-align: center;">
                        <td>{{ transaction.productName || 'N/A' }}</td>
                        <td>{{ transaction.date ? (transaction.date | date: 'dd-MM-yyyy, hh:mm a') :
                          'N/A' }}</td>
                        <td>{{ transaction.amount || 'N/A' }}</td>
                        <td>{{ transaction.currency || 'N/A'}}</td>
                        <td>{{ transaction.type || 'N/A' }}</td>
                        <td>{{ transaction.chargingMode || 'N/A'}}</td>
                      </tr>
                    </ng-container>
                    <tr *ngIf="errorMessagetransaction">
                      <td colspan="6" class="text-center">
                        <div class="alert alert-danger m-0">
                          {{ errorMessagetransaction }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <nav *ngIf="filteredTransactions.length > rowsPerPage" style="margin-top: 10px;">
              <div class="pagination-controls">
                <!-- Pagination Info -->
                <span>
                  Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filteredTransactions.length }} entries
                </span>
            
                <!-- Pagination Buttons -->
                <div>
                  <button
                    class="btn btn-secondary me-2 pre-class"
                    [disabled]="currentPage === 1 || filteredTransactions.length === 0"
                    (click)="changePage(currentPage - 1)"
                  >
                    Previous
                  </button>
            
                  <ng-container *ngFor="let page of getPages()">
                    <button [disabled]="currentPage === page"
                    [ngStyle]="{
                      'background': !isValidPage(page)  ? 'none' : '',
                      'pointer-events':!isValidPage(page)  ? 'none' : '',
                      'padding':!isValidPage(page)  ? '0' : ''
                    }" [ngClass]="(currentPage === page) ? 'led':''"
                      class="btn btn-secondary me-2"
                      [class.active]="page === currentPage"
                      (click)="changePage(page)"
                    >
                      {{ page }}
                    </button>
                  </ng-container>
            
                  <button
                    class="btn btn-secondary pre-class"
                    [disabled]="currentPage === totalPages || filteredTransactions.length === 0"
                    (click)="changePage(currentPage + 1)"
                  >
                    Next
                  </button>
                </div>
              </div>
            </nav>

            </div>
            <div class="card mb-2" style="min-height: 40px;">
              <div class="card-body  mt-2" style="cursor: pointer;" (click)="showSMSLogs()">
                <a style="padding-left: 13px;">SMS Logs</a>
              </div>
            </div>
            <div class="card mt-2 mb-3" *ngIf="showsmsLogs" style="border: 1px solid #ccc; padding: 15px;">
              <h5 class="mb-3">SMS Logs</h5>
              <div class="row mb-3">
                <div class="col-md-9">
                  <label for="rowsPerPage" class="form-label me-2">Rows per page:</label>
                  <select id="rowsPerPage" class="form-select d-inline-block w-auto" [(ngModel)]="rowsPerPage1"
                    (change)="updatePaginationsms()">
                    <option *ngFor="let size of pageSizes" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 text-end">
                  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchQuerysms"
                    (ngModelChange)="filtersms()" />
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr style="text-align: center;">
                      <th (click)="sortsms('date')">Date <span *ngIf="sortColumnsms === 'date'">{{ sortDirectionsms ===
                          'asc' ? '↑' : '↓' }}</span></th>
                      <th (click)="sortsms('message')">Message <span *ngIf="sortColumnsms === 'message'">{{
                          sortDirectionsms === 'asc' ? '↑' : '↓' }}</span></th>
                      <th (click)="sortsms('status')">Status <span *ngIf="sortColumnsms === 'status'">{{
                          sortDirectionsms
                          === 'asc' ? '↑' : '↓' }}</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="!errorMessage">
                      <tr *ngFor="let sms of paginatedsms; let i = index" style="text-align: center;">
                        <td>{{ sms.date ? (sms.date | date: 'dd-MM-yyyy, hh:mm a') :
                          'N/A' }}</td>
                        <td>{{ sms.message || 'N/A'}}</td>
                        <!-- <td>{{ sms.type || 'N/A'}}</td> -->
                        <td>{{ sms.status || 'N/A' }}</td>
                      </tr>
                    </ng-container>
                    <tr *ngIf="errorMessage">
                      <td colspan="3" class="text-center">
                        <div class="alert alert-danger m-0">
                          {{ errorMessage }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <nav *ngIf="filteredsms.length > rowsPerPage1" style="margin-top: 10px;">
              <div class="pagination-controls">
                <!-- Pagination Info -->
                <span>
                  Showing {{ getStartIndexsms() }} to {{ getEndIndexsms() }} of {{ filteredsms.length }} entries
                </span>
            
                <!-- Pagination Buttons -->
                <div>
                  <button
                    class="btn btn-secondary me-2 pre-class"
                    [disabled]="currentPage1 === 1 || filteredsms.length === 0"
                    (click)="changePage1(currentPage1 - 1)"
                  >
                    Previous
                  </button>
            
                  <ng-container *ngFor="let page of getPagessms()">
                    <button [disabled]="currentPage1 === page"
                    [ngStyle]="{
                      'background': !isValidPage(page)  ? 'none' : '',
                      'pointer-events':!isValidPage(page)  ? 'none' : '',
                      'padding':!isValidPage(page)  ? '0' : ''
                    }" [ngClass]="(currentPage1 === page) ? 'led':''"
                      class="btn btn-secondary me-2"
                      [class.active]="page === currentPage1"
                      (click)="changePage1(page)"
                    >
                      {{ page }}
                    </button>
                  </ng-container>
            
                  <button
                    class="btn btn-secondary pre-class"
                    [disabled]="currentPage1 === totalPages1 || filteredsms.length === 0"
                    (click)="changePage1(currentPage1 + 1)"
                  >
                    Next
                  </button>
                </div>
              </div>
            </nav>
            </div>

          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-template #openDeactivateuserModel let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
          <p style="margin-top: 5px;">Are you sure you want to deactivate this account?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
          <button class="btn btn-success" (click)="Deactivateuser(selectedphoneId)">
            Deactivate
          </button>

        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #addChangePasswordModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Change Password</h5>
          <button type="button" class="btn-close" (click)="onCancelchange()"></button>
        </div>
        <div class="modal-body" style="padding: 20px;margin-top: -20px;">
          <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="oldPassword">Current Password <span class="error-message">*</span></label>
              <div class="input-group">
                <input (keypress)="preventSpace($event)" maxlength="20" [type]="showOldPassword ? 'text' : 'password'"
                  id="oldPassword" autocomplete="new-password" class="form-control"
                  style="margin-top: -12px;margin-bottom: -5px;" formControlName="oldPassword"
                  placeholder="Enter Current Password" />
                <i class="fa" [ngClass]="showOldPassword ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="togglePassword('old')"
                  style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                </i>
              </div>
              <div *ngIf="oldPassword?.invalid && oldPassword?.touched" class="error-message">
                <div *ngIf="oldPassword?.errors?.['required']">Current Password is required</div>
              </div>
            </div>

            <div class="form-group">
              <label for="newPassword">New Password <span class="error-message">*</span></label>
              <div class="input-group">
                <input style="margin-top: -12px;margin-bottom: -5px;" (keypress)="preventSpace($event)" maxlength="20"
                  [type]="showNewPassword ? 'text' : 'password'" autocomplete="new-password" id="newPassword"
                  class="form-control" formControlName="newPassword" placeholder="Enter New Password" />
                <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="togglePassword('new')"
                  style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                </i>
              </div>
              <div *ngIf="newPassword?.invalid && newPassword?.touched" class="error-message">
                <div *ngIf="newPassword?.errors?.['required']">Password is required</div>
                <div *ngIf="newPassword?.errors?.['pattern']">
                  Password must be at least 8 characters long, contain at least one number, one uppercase letter, and
                  one lowercase letter
                </div>
                <div *ngIf="newPassword?.errors?.['sameAsOldPassword']">
                  New Password must be different from Current Password
                </div>
              </div>
            </div>

            <div class="form-group" style="margin-bottom: 40px;">
              <label for="confirmPassword">Confirm Password<span style="color: red;margin-left: 5px;">*</span></label>
              <div class="input-group">
                <input style="margin-top: -12px;margin-bottom: -10px;" (keypress)="preventSpace($event)" maxlength="20"
                autocomplete="new-password" [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                class="form-control" formControlName="confirmPassword" placeholder="Confirm New Password" />
              <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                (click)="togglePassword('confirm')"
                style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
              </i>
              </div>
              <div *ngIf="confirmPassword?.invalid && confirmPassword?.touched" class="error-message">
                <div *ngIf="confirmPassword?.errors?.['required']">Confirm Password is required</div>
                <div *ngIf="confirmPassword?.errors?.['mustMatch']">Passwords do not match</div>
              </div>
            </div>

            <div class="modal-footer" style="margin-top: 20px;padding: 0 !important;">
              <button type="button" class="btn custom-btn-change-password" style="margin-right:10px"
                (click)="onSubmit()">
                Change Password
              </button>
              <button type="button" class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cancel click')">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>


  </ng-template>



  <ng-template #openLogOutModel let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
          <p style="margin-top: 15px; margin-left:5px">Are you sure you want to logout ?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-success custom-btn-logout" (click)="logout()">
            Logout
          </button>
          <button class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cross click')">Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>